module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-group",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addRating($event)
      }
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beerRating.name),
      expression: "beerRating.name"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Vem är du?"
    },
    domProps: {
      "value": _vm._s(_vm.beerRating.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beerRating.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beerRating.beer),
      expression: "beerRating.beer"
    }],
    on: {
      "change": function($event) {
        _vm.beerRating.beer = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Välj en öl i listan ...")]), _vm._v(" "), _vm._l((_vm.beers), function(beer, index) {
    return _c('option', [_vm._v(_vm._s(beer.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "range-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderValue),
      expression: "sliderValue"
    }],
    staticClass: "range-input",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20",
      "step": "1"
    },
    domProps: {
      "value": _vm._s(_vm.sliderValue)
    },
    on: {
      "input": function($event) {
        _vm.sliderValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('output', {
    staticClass: "range-output",
    attrs: {
      "id": "rangeInfo"
    },
    domProps: {
      "textContent": _vm._s(_vm.total)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValid,
      "value": "Sätt betyg på ölen!"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5d68d56d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rating.vue
// module id = 26
// module chunks = 0